import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// 定義 DashboardSlice 介面，包含儀表板設置和其他狀態

interface DashboardSlice {
  dashboardSetting: {
    health: boolean;
    strength: boolean;
    model: boolean;
    firmware: boolean;
    IoT: boolean;
    map: boolean;
  };
  deleteNode:boolean;
  isMapOnly: boolean;
  isMapModal: boolean;
}
// 初始狀態，包括從本地儲存獲取的儀表板設置

const initialState: DashboardSlice = {
  // 從本地儲存獲取儀表板設置
  dashboardSetting: getDashSetting(),
  deleteNode:false,
  isMapOnly: false,
  isMapModal: false,
};
// 創建儀表板切片
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    // 設定儀表板設置
    setDashboardSetting: (state, action: PayloadAction<DashboardSlice["dashboardSetting"]>) => {
      state.dashboardSetting = action.payload;
    },
    // 設定是否僅顯示地圖
    setIsMapOnly: (state, action: PayloadAction<boolean>) => {
      state.isMapOnly = action.payload;
    },
    // 設定是否顯示地圖模態框
    setIsMapModal: (state, action: PayloadAction<DashboardSlice["isMapModal"]>) => {
      state.isMapModal = action.payload;
    },
    // 設定可刪除連線的設備
    setDeleteNode: (state, action: PayloadAction<boolean>) => {
      state.deleteNode = action.payload;
    },
    
  },
});
// 匯出動作創建函數

export const { setDashboardSetting, setIsMapOnly, setIsMapModal,setDeleteNode } = dashboardSlice.actions;

// 匯出儀表板切片

export default dashboardSlice;

// 從本地儲存獲取儀表板設置的函數

function getDashSetting() {
  const cache = localStorage.getItem("DashboardSetting");
  const initial = {
    health: true,
    strength: true,
    model: true,
    firmware: true,
    IoT: false,
    map: true,
  };
  if (cache) {
    const setting = JSON.parse(cache);
    // console.log("setting",setting)
    //override old version of key value ""
    // 如果 setting.health 是 false 則 return initial 預設值
    return !setting.health ? initial : setting;
  }

  return initial;
}
